import ApiRequest from "@/helpers/ApiRequest";
import GetHeaders from "@/helpers/GetHeaders";
import {
    CHANGE_CLASSIFICATION_STATE,
    CHANGE_CURRENT_STAGE,
    CHANGE_BATCHING_STATUS,
    CHANGE_CLASSIFICATION_PROGRESS
} from "@/store/mutation-types";

export default {
  actions: {
    initiateClassification: async ({dispatch},payload) => {
      return ApiRequest.explorePost("initiate_classification", payload, GetHeaders.dataHeaders()).then(
        res => {
          dispatch("setClassificationStatus", true);
          dispatch("setClassificationStage", 1);
          return res.data;
        }
      );
    },
    restartClassification: async ({dispatch},payload) => {
      return ApiRequest.explorePost("retry_classification", payload, GetHeaders.dataHeaders()).then(
        res => {
          dispatch("setClassificationStatus", true);
          dispatch("setClassificationStage", 1);
          return res.data;
        }
      );
    },
    initiateManualBatching: async ({dispatch},payload) => {
      return ApiRequest.explorePost("initiate_manual_batching", payload, GetHeaders.dataHeaders()).then(
        res => {
          //dispatch("setBatchingStatus", res.data);
          return res.data;
        }
      );
    },
    getCatDescription: async (_, payload) => {
      return ApiRequest.explorePost("get_category_description", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    getBatchingStatus: async ({dispatch}, payload) => {
      return ApiRequest.exploreGet("fetch_batching_status/" + payload, GetHeaders.dataHeaders()).then(
        res => {
          dispatch("setBatchingStatus", res.data)
          return res.data
        }
      );
    },
    getBatchingProgress: async (_, payload) => {
      return ApiRequest.exploreGet("fetch_batching_progress/" + payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    getClassificationStatus: async ({dispatch}, payload) => {
      return ApiRequest.exploreGet("fetch_classification_status/" + payload, GetHeaders.dataHeaders()).then(
        res => {
          dispatch("setClassificationProgress", res.data)
          return res.data
        }
      );
    },
    getClassificationData: async (_, payload) => {
      return ApiRequest.exploreGet("get_classified_data/" + payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    clusterClassifiedData: async (_, payload) => {
      return ApiRequest.explorePost("distance_clustering", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    getClassifiedFilters: async (_, payload) => {
      return ApiRequest.explorePost("classified_filters", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    updateClassifiedFilter: async (_, payload) => {
      return ApiRequest.explorePost("update_classified_filter", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    splitClassifiedFilter: async (_, payload) => {
      return ApiRequest.explorePost("split_classified_filter", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    mergeClassifiedFilters: async (_, payload) => {
      return ApiRequest.explorePost("merge_classified_filters", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    renameClassifiedFilter: async (_, payload) => {
      return ApiRequest.explorePost("rename_classified_filter", payload, GetHeaders.dataHeaders()).then(
        res => {
          return res.data
        }
      );
    },
    delClassificationData: async ({dispatch},payload) => {
      return ApiRequest.exploreDelete("discard_classified_data/" + payload, GetHeaders.dataHeaders()).then(
        res => {
          dispatch("setClassificationStatus", false)
          dispatch("setClassificationStage", 0)
          return res.data
        }
      );
    },
    setClassificationStatus: async ({commit}, payload) => {
      commit(CHANGE_CLASSIFICATION_STATE, payload);
    },
    setClassificationProgress: async ({commit}, payload) => {
      commit(CHANGE_CLASSIFICATION_PROGRESS, payload);
    },
    setBatchingStatus: async ({commit}, payload) => {
      commit(CHANGE_BATCHING_STATUS, payload);
    },
    setClassificationStage: async ({commit}, payload) => {
      //console.log("Setting stage", payload);
      commit(CHANGE_CURRENT_STAGE, payload);
    }
  },
  getters: {},
  mutations: {
    [CHANGE_CLASSIFICATION_STATE](state, payload) {
      state.classificationStatus = payload;
    },
    [CHANGE_CURRENT_STAGE](state, payload) {
      state.currentStage = payload;
    },
    [CHANGE_BATCHING_STATUS](state, payload) {
      console.log("Setting batching status", payload);
      state.batchingStatus = payload.status;
    },
    [CHANGE_CLASSIFICATION_PROGRESS](state, payload) {
      state.stats = payload;
    },
  },
  state: {
    batchingStatus: 'No',
    classificationStatus: false,
    currentStage: 0,
    stats: {
      all_concepts:0,
      completed_tasks:590,
      description:"Initializing...",
      noise_removed:0,
      percentage_completion:0,
      status:0,
      total_tasks:0
    }
  }
};
